const TIME_ZONE_LESS_TIMESTAMP =
  /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2}(?:\.\d+)?)$/u;

/**
 * D1/SQLite stores UTC timestamps without a trailing timezone marker. Browsers
 * otherwise interpret those values in the device timezone, which can shift an
 * order time by several hours. ISO values that already carry a timezone are
 * kept unchanged.
 */
export function normalizeStoredTimestamp(value: string): string {
  const trimmed = value.trim();
  const match = TIME_ZONE_LESS_TIMESTAMP.exec(trimmed);
  return match ? `${match[1]}T${match[2]}Z` : trimmed;
}

export function parseStoredTimestamp(value: string): number {
  if (!value) return Number.NaN;
  return Date.parse(normalizeStoredTimestamp(value));
}
